module.exports = __webpack_public_path__ + "media/images/presential-88cf788e7b10f12afa8d3616f2873354.svg";